import { render, staticRenderFns } from "./AppStatueDev.vue?vue&type=template&id=2b5e1400&scoped=true&"
import script from "./AppStatueDev.vue?vue&type=script&lang=js&"
export * from "./AppStatueDev.vue?vue&type=script&lang=js&"
import style0 from "./AppStatueDev.vue?vue&type=style&index=0&id=2b5e1400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e1400",
  null
  
)

export default component.exports